let elements = {

	'HTMLElement@figcation'           : 'figcaption',
	'HTMLElement@figure'              : 'figure',
	'HTMLElement@footer'              : 'footer',
	'HTMLElement@header'              : 'header',
	'HTMLElement@main'                : 'main',
	'HTMLElement@mark'                : 'mark',
	'HTMLElement@article'             : 'article',
	'HTMLElement@aside'               : 'aside',
	'HTMLElement@bdi'                 : 'bdi',
	'HTMLElement@nav'                 : 'nav',
	'HTMLElement@rp'                  : 'rp',
	'HTMLElement@rt'                  : 'rt',
	'HTMLElement@ruby'                : 'ruby',
	'HTMLElement@section'             : 'section',
	'HTMLElement@summary'             : 'summary',
	'HTMLElement@wbr'                 : 'wbr',

	'HTMLHtmlElement@html'            : 'html',
	'HTMLAnchorElement@a'             : 'a',
	'HTMLAreaElement@area'            : 'area',
	'HTMLBRElement@br'                : 'br',
	'HTMLBaseElement@base'            : 'base',
	'HTMLBodyElement@body'            : 'body',
	'HTMLButtonElement@button'        : 'button',
	'HTMLCanvasElement@canvas'        : 'canvas',
	'HTMLContentElement@content'      : 'content',
	'HTMLDListElement@dl'             : 'dl',
	'HTMLDataElement@data'            : 'data',
	'HTMLDataListElement@datalist'    : 'datalist',
	'HTMLDivElement@div'              : 'div',
	'HTMLDocument@document'           : 'document',
	'HTMLFieldSetElement@fieldset'    : 'fieldset',
	'HTMLFormElement@form'            : 'form',
	'HTMLFrameSetElement@framset'     : 'framset',
	'HTMLHRElement@hr'                : 'hr',
	'HTMLHeadElement@head'            : 'head',
	'HTMLHeadingElement@h'            : 'h',
	'HTMLIFrameElement@iframe'        : 'iframe',
	'HTMLImageElement@img'            : 'img',
	'HTMLInputElement@input'          : 'input',
	'HTMLKeygenElement@keygen'        : 'keygen',
	'HTMLLIElement@li'                : 'li',
	'HTMLLabelElement@label'          : 'label',
	'HTMLLegendElement@legend'        : 'legend',
	'HTMLLinkElement@link'            : 'link',
	'HTMLMapElement@map'              : 'map',
	'HTMLMediaElement@media'          : 'media',
	'HTMLMetaElement@meta'            : 'meta',
	'HTMLModElement@mod'              : 'mod',
	'HTMLOListElement@ol'             : 'ol',
	'HTMLObjectElement@object'        : 'object',
	'HTMLOptGroupElement@optgroup'    : 'optgroup',
	'HTMLOptionElement@option'        : 'option',
	'HTMLOutputElement@output'        : 'output',
	'HTMLParagraphElement@p'          : 'p',
	'HTMLParamElement@param'          : 'param',
	'HTMLPictureElement@picture'      : 'picture',
	'HTMLPreElement@pre'              : 'pre',
	'HTMLQuoteElement@quote'          : 'quote',
	'HTMLScriptElement@script'        : 'script',
	'HTMLSelectElement@select'        : 'select',
	'HTMLShadowElement@shadow'        : 'shadow',
	'HTMLSpanElement@span'            : 'span',
	'HTMLStyleElement@style'          : 'style',
	'HTMLTableCaptionElement@caption' : 'caption',
	'HTMLTableCellElement@td'         : 'td',
	'HTMLTableColElement@col'         : 'col',
	'HTMLTableElement@table'          : 'table',
	'HTMLTableRowElement@tr'          : 'tr',
	'HTMLTemplateElement@template'    : 'template',
	'HTMLTextAreaElement@textarea'    : 'textarea',
	'HTMLTitleElement@title'          : 'title',
	'HTMLUListElement@ul'             : 'ul',
	'HTMLUnknownElement@unknown'      : 'unknown',
	'HTMLDetailsElement@details'      : 'details',
	'HTMLDialogElement@dialog'        : 'dialog',
	'HTMLUnknownElement@menuitem'     : 'menuitem',
	'HTMLMeterElement@meter'          : 'meter',
	'HTMLProgressElement@progress'    : 'progress',
	'HTMLTimeElement@time'            : 'time',

	'SVGElement@svg'                  : 'svg',
	'HTMLAudioElement@audio'          : 'audio',
	'HTMLEmbedElement@embed'          : 'embed',
	'HTMLSourceElement@source'        : 'source',
	'HTMLTrackElement@track'          : 'track',
	'HTMLVideoElement@video'          : 'video',
};

export {
	elements
};
